import { render, staticRenderFns } from "./DeleteNoteDialog.vue?vue&type=template&id=52744179&"
import script from "./DeleteNoteDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteNoteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports